import classnames from 'classnames';
import upperCase from 'lodash/upperCase';
import React from 'react';
import { useSelector } from 'react-redux';
import useMembershipButton from '../../hooks/useMembershipButton';
import { profileSelectors } from '../../redux/selectors/profile';
import routes from '../../routes/constants';
import text from '../../text';
import Button from './Button';
var MembershipButton = function(param) {
    var className = param.className, _param_variant = param.variant, variant = _param_variant === void 0 ? 'primary' : _param_variant, isUppercase = param.isUppercase;
    var canUserStartTrial = useSelector(profileSelectors.getCanUserStartTrial);
    var canUserUpgrade = useSelector(profileSelectors.getCanUserUpgrade);
    var handleMembershipClick = useMembershipButton().handleMembershipClick;
    var label = isUppercase ? upperCase(text(canUserStartTrial ? 'startTrial' : 'upgrade')) : text(canUserStartTrial ? 'startTrial' : 'upgrade');
    if (!canUserStartTrial && !canUserUpgrade) return null;
    return /*#__PURE__*/ React.createElement(Button, {
        id: "MembershipButton",
        className: classnames(className),
        variant: variant,
        onClick: function() {
            return handleMembershipClick({
                redirectTo: {
                    path: "".concat(routes.user.profile, "?focusedTab=membership"),
                    label: text('navigateToRoute', {
                        navigation: 'Back',
                        routeName: text('account')
                    })
                }
            });
        }
    }, label);
};
export default MembershipButton;
